export class FiltroRegiaoAdministrativa {
	
	nome: string;
}